import {PixiUtils} from "html-living-framework";
interface IZeplinData {name: string, rect: {x: number, y: number, width: number, height: number}};

/** using my zeplin json exporter plugin */
export function zeplinSprite(pData: IZeplinData, pSpritesheet?: string | string[]) {
    const newSprite = PixiUtils.makeSprite(pData.name, pSpritesheet);
    newSprite.anchor.set( // from zero to one, not in pixels
        (newSprite.texture.width - pData.rect.width) / newSprite.texture.width,
        (newSprite.texture.height - pData.rect.height) / newSprite.texture.height,
    );
    newSprite.position.set(pData.rect.x, pData.rect.y);
    return newSprite;
}